import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from "angular-datatables";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Select2Module } from 'ng-select2-component';
import { VideoComponent } from './video/video.component';
import { documentsCardsComponent } from './documentsCards/documentsCards.component';
import { documentsTableComponent } from './documentsTable/documentsTable.component';
import { AddTokenPipe } from 'src/app/pipes/addToken';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { EventInfoComponent } from './event-info/events-info.component';
import { EventComponent } from './event/event.component';
import { TableOrderCrmComponent } from './table-order-crm/table-order-crm.component';
import { StatisticsCrmComponent } from './statistics-crm/statistics-crm.component';
import { TableOrderPubComponent } from './table-order-pub/table-order-pub.component';
import { EditOrderPubComponent } from './edit-order-pub/edit-order-pub.component';
import { CommonDistributorLogotipoComponent } from './distributor/logotipo/distributor-logotipo.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { ExpensesDashboardComponent } from './expenses-dashboard/expenses-dashboard.component';
import { CommonDistributorDetailComponent } from './distributor/detail/distributor-detail.component';
import { CommonDistributorBillingComponent } from './distributor/billing/distributor-billing.component';
import { CommonMaterialSendingComponent } from './distributor/material-sending/material-sending.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FeriaOrderTableComponent } from './feria-order-table/feria-order-table.component';
import { FeriaOrderDetailComponent } from './feria-order-detail/feria-order-detail.component';
import { GalleryComponent } from './gallery/gallery.component';


@NgModule({
  declarations: [
    VideoComponent,
    ProgressBarComponent,
    documentsCardsComponent,
    documentsTableComponent,
    EventInfoComponent,
    EventComponent,
    AddTokenPipe,
    EventComponent,
    EventInfoComponent,
    TableOrderCrmComponent,
    TableOrderPubComponent,
    EditOrderPubComponent,
    StatisticsCrmComponent,
    CommonDistributorLogotipoComponent,
    CommonDistributorDetailComponent,
    CommonDistributorBillingComponent,
    CommonMaterialSendingComponent,
    ExpensesDashboardComponent,
    FeriaOrderTableComponent,
    FeriaOrderDetailComponent,
    GalleryComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    DataTablesModule,
    FormsModule,
    ReactiveFormsModule,
    Select2Module,
    NgxDropzoneModule,
    FontAwesomeModule
  ],
  exports: [
    VideoComponent,
    ProgressBarComponent,
    documentsCardsComponent,
    documentsTableComponent,
    EventInfoComponent,
    EventComponent,
    AddTokenPipe,
    EventComponent,
    EventInfoComponent,
    TableOrderCrmComponent,
    TableOrderPubComponent,
    EditOrderPubComponent,
    StatisticsCrmComponent,
    CommonDistributorLogotipoComponent,
    CommonDistributorDetailComponent,
    CommonDistributorBillingComponent,
    CommonMaterialSendingComponent,
    ExpensesDashboardComponent,
    FeriaOrderTableComponent,
    FeriaOrderDetailComponent,
    GalleryComponent
  ]
})
export class SharedModule { }
